import type { TileColor } from './home-schema.js';

export const TILE_COLORS: Record<TileColor, { bg: string; fg: string; ring: string }> = {
  slate:      { bg: 'bg-[#3F4754]',  fg: 'text-stone-100',  ring: 'ring-[#262C36]' },
  navy:       { bg: 'bg-[#1F3357]',  fg: 'text-stone-100',  ring: 'ring-[#0E1A30]' },
  forest:     { bg: 'bg-[#2F4F3D]',  fg: 'text-stone-100',  ring: 'ring-[#16291F]' },
  sage:       { bg: 'bg-[#7E8F6E]',  fg: 'text-stone-50',   ring: 'ring-[#4F5C42]' },
  gold:       { bg: 'bg-[#B8924A]',  fg: 'text-stone-50',   ring: 'ring-[#6E5A2D]' },
  amber:      { bg: 'bg-[#C97A2E]',  fg: 'text-stone-50',   ring: 'ring-[#7C461A]' },
  terracotta: { bg: 'bg-[#9C4A3A]',  fg: 'text-stone-50',   ring: 'ring-[#5E2C22]' },
  plum:       { bg: 'bg-[#583E5E]',  fg: 'text-stone-50',   ring: 'ring-[#332238]' },
  rose:       { bg: 'bg-[#A05D6A]',  fg: 'text-stone-50',   ring: 'ring-[#5E353D]' },
  mist:       { bg: 'bg-[#6B7E8E]',  fg: 'text-stone-50',   ring: 'ring-[#3F4C57]' },
  ink:        { bg: 'bg-[#1A1D24]',  fg: 'text-stone-100',  ring: 'ring-[#000000]' },
  parchment:  { bg: 'bg-[#E8DFC9]',  fg: 'text-stone-800',  ring: 'ring-[#B8AB89]' },
};

export const TILE_COLOR_OPTIONS: TileColor[] = Object.keys(TILE_COLORS) as TileColor[];
